export enum cacheKeys {
  remoteConfig = 'welcome_dialog_config',
  banners = 'banners',
  statistics = 'statistics',
  whatsNewSrvs = 'whatsNewSrvs',
  popularSrvs = 'popularSrvs',
  getpartners = 'getpartners',
  trendingSrvs = 'trendingSrvs',
  categories = 'categories',
  allServices = 'allServices',
  deptServices = 'deptServices',
  schemeApplyData = 'schemeApplyData',
  userCounts = 'userCounts'
}
